"use client";
import { useRef } from "react";
import { useInView } from "@/hooks/useFramerMotion";
const TestimonialsInViewWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { amount: "some", once: true });

  return <div ref={ref}>{isInView && <>{children}</>}</div>;
};

export default TestimonialsInViewWrapper;
